import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import DatePickerCustom from '../../../commonModules/interface/DatePickerCustom';
import InputText, { InputSelectMagasin, InputSelectMulti } from '../../../commonModules/interface/form-input-inline';
import { GroupCheckbox, SingleCheckbox } from '../../../commonModules/MUI/RadioAndCheckbox';


export const SearchPhone = (props) => {
    return (
        <InputText
            label="Téléphone"
            onChange={props.onChange}
            error={props.error}
            type="text" 
            value={props.value} 
            name="phone" 
        />
    )
}

export const SearchSystemStatus = (props) => {
    // let options = [
    //     "OK",
    //     "PaygBlocked",
    //     "NoConnection",
    //     "InitPAYG",
    //     'Dispossess',
    //     'Demo',
    //     "FullyPaid",
    //     "PaymentLate" 
    // ]
    let options = [
        {value:"OK", label: "À Jour"},
        {value:"PaymentLate", label: "En Retard"},
        {value:"PaygBlocked", label: "Bloqué"},
        {value:"NoConnection", label: "Non Connecté"},
        {value:'Dispossess', label: "Dépossédé"},
        {value:"FullyPaid", label: "Soldé"},
        {value:"InitPAYG", label: "InitPAYG"},
        {value:'Demo', label: "Demo"},
    ]
    return (
        // <InputSelectMagasin
        //     label="Statut Box"
        //     options={options}
        //     onChange={(option) => props.onChange(option, "systemStatus")}
        //     error={props.error}
        //     value={props.value} 
        //     name="systemStatus" 
        // />
        <GroupCheckbox label="Statut Box" error={props.error} direction="column">
            {options.map(current => 
                <SingleCheckbox 
                    label={current.label} 
                    value={current.value} 
                    checked={props.value.includes(current.value)} 
                    onChange={() => props.onChange("systemStatus", current.value )} />
            )}
        </GroupCheckbox>
    )
}

export const SearchCommercial = (props) => {
    let options = []
    if (!isEmpty(props.AGENTS)){
        options = Object.values(props.AGENTS).map( agent => ({value: agent.id, label: `${agent.name} - ${agent.externalid}`}))
    }
    // options.unshift({value: "", label: "Tous" })
    return (
        <InputSelectMagasin
            label="Commercial"
            options={options}
            onChange={(option) => props.onChange(option, "actualCommercial")}
            error={props.error}
            value={props.value} 
            name="actualCommercial" 
        />
    )
}

export const SearchActivationDateStart = (props) => {
    return (
        <DatePickerCustom
            required
            label="Du"
            handleChange={(date) => props.onChange(date, "timeStart")}
            value={props.value}
            id="timeStart"
            maxDate={props.timeStop || new Date()}
            
        />
    )
}

export const SearchActivationDateEnd = (props) => {
    return (
        <DatePickerCustom
            required
            label="Au"
            handleChange={(date) => props.onChange(date, "timeStop")}
            value={props.timeStop}
            id="timeStop"
            maxDate={new Date()}
            minDate={props.timeStart || new Date()}
        />  
    )
}